// using a function to create the state for each type of request, since they all use the same state options

const createState = () => {
   return {
      active: null,
      requests: null,
      uniqueServices: [],
      statuses: ["finished", "unfinished", "untouched"],
      filters: {
         name: "",
         status: "all",
         incompleteServices: "any",
         sort: "newest-to-oldest",
         dateMin: null,
         dateMax: null
      }
   }
}

export default createState;